/**
 * FieldError — muestra un mensaje de error inline bajo un campo.
 */
export function FieldError({ msg }) {
  if (!msg) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 5,
        marginTop: 4,
        color: "#f87171",
        fontSize: "0.78rem",
      }}
    >
      <i
        className="fa-solid fa-circle-exclamation"
        style={{ fontSize: "0.72rem" }}
      />
      {msg}
    </div>
  );
}

/**
 * CedulaStatus — muestra el resultado de la búsqueda de cédula.
 */
export function CedulaStatus({ estado }) {
  if (estado === "idle") return null;

  const cfg = {
    buscando: {
      color: "#60a5fa",
      icon: "fa-circle-notch fa-spin",
      text: "Buscando…",
    },
    local: {
      color: "#4ade80",
      icon: "fa-circle-check",
      text: "Datos cargados desde el registro local",
    },
    tse: {
      color: "#4ade80",
      icon: "fa-circle-check",
      text: "Datos cargados desde el TSE (Registro Nacional CR)",
    },
    no_encontrado: {
      color: "#fbbf24",
      icon: "fa-triangle-exclamation",
      text: "Cédula no encontrada. Ingresá el nombre manualmente.",
    },
    error: {
      color: "#f87171",
      icon: "fa-circle-exclamation",
      text: "No se pudo consultar el registro. Ingresá el nombre manualmente.",
    },
  }[estado];

  if (!cfg) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginTop: 5,
        color: cfg.color,
        fontSize: "0.78rem",
      }}
    >
      <i className={`fa-solid ${cfg.icon}`} />
      {cfg.text}
    </div>
  );
}

/**
 * ForeignToggle — checkbox "Es número extranjero" para teléfono/placa.
 */
export function ForeignToggle({ checked, onChange, label }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginTop: 5,
        fontSize: "0.78rem",
        color: "#9ca3af",
        userSelect: "none",
        cursor: "pointer",
      }}
    >
      <input
        type="checkbox"
        checked={!!checked}
        onChange={onChange}
        style={{ accentColor: "#f97316", cursor: "pointer" }}
      />
      <span style={{color:"#9ca3af"}}>{label}</span>
    </div>
  );
}
